module.exports = __webpack_public_path__ + "static/media/proceso_de_mantenimiento.7b26c5cd.jpg";